const PRIMARY = '#dc3545';
const SECONDARY = '#262024';

export {PRIMARY, SECONDARY};